import { useQuery } from '@apollo/client/react/hooks';
import { useMemo } from 'react';

import { GetStoryDocument } from '../../graphql/generated/graphql';
import { isStory } from '../../utils';
import { NotFoundError, BadRequestError } from '../../utils/errors';

interface Props {
  id: string;
  company: string;
  withStoryPage: boolean;
}

export const useGetStory = ({ company, id, withStoryPage }: Props) => {
  const { data, loading, ...rest } = useQuery(GetStoryDocument, {
    variables: { id, withStoryPage },
  });

  const story = useMemo(() => {
    if (loading) return undefined;
    if (data?.story) {
      const { story } = data;
      if (!story) throw new NotFoundError('Story not found');
      if (
        !story.Products?.some((product) => product?.Company?.Slug === company)
      )
        throw new BadRequestError(
          `Story ${story.id} is not owned by company ${company}`
        );

      if (isStory(story)) return story;
    }
  }, [data, loading, company]);

  return { story, ...rest };
};
